import { Directive, ElementRef, Output, EventEmitter, AfterViewInit, ChangeDetectorRef } from "@angular/core";

@Directive({
  selector: "[appEllipsisDetect]",
})
export class EllipsisDetectDirective implements AfterViewInit {
  @Output() isEllipsisActive: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private el: ElementRef,
    private cdr: ChangeDetectorRef
  ) { }

  public ngAfterViewInit(): void {
    this.checkEllipsis();
  }

  private checkEllipsis(): void {
    const element = this.el.nativeElement;
    const isOverflowing = element.offsetWidth < element.scrollWidth;
    this.cdr.detectChanges();
    this.isEllipsisActive.emit(isOverflowing);
  }
}
